import React, {useEffect, useState} from "react";
import common from "../../translations/it/common.json";
import Button from "../../components/Button/Button";
import Table from "../../components/table/Table";
import MediaQueryUtils from "../../utils/MediaQueryUtils";
import InserisciUtente from "./InserisciModificaUtente/InserisciUtente";
import ModificaUtente from "./InserisciModificaUtente/ModificaUtente";
import style from "../sportelli/ElencoSportelli.module.css";
import Pagination from "../../components/pagination/Pagination";
import Spinner from "../../components/spinner/Spinner";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import RicercaUtenti from "./RicercaUtenti/RicercaUtenti";
import Utils from "../../utils/Utils";
import {setSearch} from "../../actions/IndexActions";
import ApmsService from "../../services/ApmsService";


function ElencoUtenti(props) {

    const [flagButtonModale, setFlagButtonModale] = useState(false)
    const [rows, setRows] = useState([])
    const [pagination, setPagination] = useState({size: 5, page: 0, sort: "nome", order: "asc"})
    const [modalBodyModifica, setModalBodyModifica] = useState(null)
    const [modalBodyInserisci] = useState(<InserisciUtente getUtenti={getUtenti}/>)
    const [showSpinner, setShowSpinner] = useState(false)
    let isPageWide = MediaQueryUtils('(min-width: 1200px)')
    const history = useHistory()
    const button = useSelector(state => state.searchReducer)
    const dispatch = useDispatch()
    const [cols,setCols] = useState( [])
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    useEffect(() => {
        Utils.createColsElencoUtenti(setShowSpinner,setCols,onClickButtonModifica,style.buttonTable)
    },[])

    useEffect(() => {
        getUtenti()
    }, [pagination.page,pagination.sort,pagination.order])

    function getUtenti() {
        setShowSpinner(true)
        let params = {
            applicazione : "RAF",
            size: pagination.size,
            page: pagination.page,
            sort: pagination.sort,
            order: pagination.order.toLowerCase(),

        }
        ApmsService.ricercaUtenti(params).then(res => {
            let newPagination = {...pagination}
            newPagination.totalPages = res.data.totalElements <= pagination.size ? 1 : Math.ceil(res.data.totalElements / pagination.size)
            newPagination.totalElements = res.data.totalElements
            let listaUtenti = Utils.createListaUtentiFromApms(res.data.elementi)
            setRows(listaUtenti)
            setPagination(newPagination)
            history.push({utenti: listaUtenti})
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Utenti: " + reason)
            setShowSpinner(false)
        })

    }

    function changePage(newPage) {
        let newPagination = {...pagination}
        newPagination.page = newPage
        setPagination(newPagination)
    }
    function setPaginationSort(sort,order){
        let newPagination = {...pagination}
        if(sort === "codiceFiscale"){
            newPagination.sort = "codice_fiscale"
        }else{
            newPagination.sort = sort
        }
        newPagination.order = order
        setPagination(newPagination)
    }

    function onClickButtonModifica(id) {
        history.location.utenti.forEach(utente => {
            if (utente.id === id) {
                history.push({utenti: history.location.utenti,vecchioRuolo:utente.ruolo})
                let utenteModifica = {...utente}
                let enteModifica = utenteModifica.ente.split("|")
                let enteSelect = []
                enteModifica.forEach(ente => {
                    let enteSplit = ente.split(";")
                    enteSelect.push(enteSplit[3])
                })
                utenteModifica.ente = enteSelect
                setModalBodyModifica(<ModificaUtente state={utenteModifica} getUtenti={getUtenti}/>)
            }
        })
        document.getElementById("modificaUtente").click();
    }

    function onClickInserisciAnnulla(){
        if(button && button.buttonFlag){
            dispatch(setSearch(false))
            setFlagButtonModale(true)
            getUtenti()
        }

    }

    function onClickInserisci(){
        setFlagButtonModale(false)
    }

    function renderButtonBody(){
        if(!flagButtonModale) {
            return (
                <Button
                    id={"inserisciUtente"}
                    style={{height: "60px", width: "300px"}}
                    typeButton={"Blue"}
                    text={common.ElencoUtenti.buttonInserisci}
                    dataTarget={"modalInserisciUtente"}
                    dataToggle={"modal"}
                    body={modalBodyInserisci}
                    header={"Dati utente"}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                />
            )
        }
        else{
            return (
                <Button
                    id={"inserisciUtente"}
                    style={{height: "60px", width: "300px"}}
                    typeButton={"Blue"}
                    text={common.ElencoUtenti.buttonInserisci}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                    onClick={onClickInserisci}
                />
            )

        }
    }

    function renderButtonBody2(){
        return (
            <Button
                id={"AnnullaUtente"}
                typeButton={"Blue"}
                style={{height: "60px", width: "300px"}}
                text={"Annulla"}
                dataBackdrop={"static"}
                dataKeyboard={false}
                icon={button && button.buttonFlag && Utils.IconAnnullaElenchi()}
                onClick={onClickInserisciAnnulla}
            />
        )
    }

    return (
        <div>
            <Spinner show={showSpinner}/>
            <div className={"pt-4"}>
                <div className={"row"} style={{margin: "0", width: "100%"}}>
                    <div className="col-1" style={{marginRight: !isPageWide ? "2rem" : "0"}}>
                        <svg width={"70"} viewBox="0 0 24 24" id="it-user"
                             xmlns="http://www.w3.org/2000/svg"
                             style={{background: "rgb(195 224 236)", borderRadius: "100px", padding: "15px"}}>
                            <path
                                d="M12 13a4 4 0 004-4V6a4 4 0 00-8 0v3a4 4 0 004 4zM9 6a3 3 0 016 0v3a3 3 0 01-6 0zm11 16h-1a7 7 0 00-14 0H4a8 8 0 0116 0z"/>
                            <path fill="none" d="M0 0h24v24H0z"/>
                        </svg>
                    </div>

                    <div className={sessioneUtente?.ruolo?.toUpperCase() !== "RAF-RDSS"?"col-6":"col-7"} style={{display: "flex", alignItems: "center"}}>
                        <h1 className={"h5"} style={{fontWeight: "bold",fontSize:"28px"}}>{common.ElencoUtenti.titolo}</h1>
                    </div>
                    <div className="col-3" style={{
                        minWidth: "fit-content",
                        minHeight: "80px"
                    }}>
                        { button && button.buttonFlag ?
                            renderButtonBody2()
                             :
                            renderButtonBody()
                        }
                    </div>
                    <div className="col-3">
                        <Button
                            id={"modificaUtente"}
                            typeButton={"Blue"}
                            style={{display: "none"}}
                            dataTarget={"modalModificaUtente"}
                            dataToggle={"modal"}
                            dataBackdrop={"static"}
                            dataKeyboard={false}
                            body={modalBodyModifica}
                            header={"Modifica Utente"}
                        />
                    </div>
                </div>
            </div>

            {button && button.buttonFlag &&
            <div>
                <RicercaUtenti getUtenti={getUtenti}/>
            </div>
            }

            <div style={{marginTop: "50px"}} className={button && button.buttonFlag && style.backgroundMode}>
                <Table
                    cols={cols}
                    rows={rows}
                    id={"tabellaUtenti"}
                    title={"Elenco Utenti Registro"}
                    setSort={setPaginationSort}
                />
                {rows && rows.length > 0 ?  <Pagination pagination={pagination} changePage={changePage}/> : <></> }
            </div>
        </div>
    );

}

export default ElencoUtenti;
